import { render, staticRenderFns } from "./PreviousTreatmentPeriod.vue?vue&type=template&id=43d6a544&scoped=true&"
import script from "./PreviousTreatmentPeriod.vue?vue&type=script&lang=js&"
export * from "./PreviousTreatmentPeriod.vue?vue&type=script&lang=js&"
import style0 from "./PreviousTreatmentPeriod.vue?vue&type=style&index=0&id=43d6a544&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d6a544",
  null
  
)

export default component.exports